/**
 * 訂單容器 API（ORDER_CONTAINER_FRONT_GET_ITEM 等）回傳物件中，
 * param / pet / product 等明細多在 orders.items[0]，容器頂層沒有 param。
 * 訂單明細頁多處假設「明細列」形狀（orderItem.param），將第一筆明細合併到同一物件，
 * 並保留容器的 uuid、type、displayId、orders 等欄位。
 */
export default function mergeContainerOrderItemForDetail (container) {
  if (!container || !Array.isArray(container.orders?.items) || container.orders.items.length === 0) {
    return container
  }
  if (container.param) {
    return container
  }
  const first = container.orders.items[0]
  /** API 容器層 params（is_container=1 對應列）；金額加總須用此欄，勿與合併後根上 params（可能為訂單明細）混用 */
  const containerLevelParams = Array.isArray(container.params) ? [...container.params] : []
  return {
    ...container,
    ...first,
    uuid: container.uuid,
    type: container.type,
    displayId: container.displayId,
    parent_id: container.parent_id,
    parentOrderContainerUuid: container.parentOrderContainerUuid,
    params: (container.params && container.params.length > 0)
      ? container.params
      : (Array.isArray(first.params) ? first.params : []),
    containerLevelParams,
  }
}
